import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/api-url-helper';
import { CommonService } from 'src/app/services/common/common.service';
import { OrderCartDialogComponent } from '../order-cart-dialog/order-cart-dialog.component';
import { AddSessionDialogComponent } from '../add-session-dialog/add-session-dialog.component';
import { currencyIcons } from 'src/app/models/commonModel';

@Component({
    selector: 'app-session-pass-dialog',
    templateUrl: './session-pass-dialog.component.html',
    styleUrls: ['./session-pass-dialog.component.scss'],
    standalone: false
})
export class SessionPassDialogComponent implements OnInit {

  // Common Properties
  customerId: any;
  passList: any = [];
  selectedPassId: any = null;
  amountIcon: any;
  selectedPassIdRadio: any;
  showDetails: boolean = false;
  activePass: boolean = false;
  activePassData: any = [];
  classSessionData: any;
  selectedPassData: any = [];
  currency: any;

  constructor(
    private dialogRef: MatDialogRef<SessionPassDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commonService: CommonService,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private api: ApiUrlHelper,
    private dialog: MatDialog) {
    this.customerId = data.customerId;
    this.classSessionData = data.classSessionData;
    this.currency = currencyIcons
  }
  ngOnInit(): void {
    this.getPassList();
  }

  cancel() {
    this.dialogRef.close(false);
  }

  getPassList(): void {
    let api = this.api.apiUrl.Payment.GetPassList.replace("{Id}",  this.customerId).replace("{ClassSessionId}", this.classSessionData.classSessionId);
    this.spinner.show();
    this.commonService.doGet(api).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          this.passList = response.data;
          this.passList = this.passList.filter(e => {
            return new Date(e.expiryDate) >= new Date(this.classSessionData.sessionStartDateTime);
          });
          if(this.passList.length>0){
            if(this.passList.find(pass => pass.passType === "Free") != undefined || null){
              this.activePassData = this.passList.find(pass => pass.passType === "Free");
              this.activePass = true;
              this.selectedPassId = this.activePassData.paymentPassId;
              this.showDetails = true;
            }
          }
          this.spinner.hide();
        } else {
          this.toaster.error(response.message);
          this.spinner.hide();
        }
      },
    });
  }

  showDetailsForPass(passId: any) {
    if (this.selectedPassIdRadio === passId) {
      this.showDetails = !this.showDetails; // toggle detail visibility
    } else {
      this.selectedPassIdRadio = passId; // update selected pass id
      this.showDetails = true; // show details for the selected pass
    }
  }

  addToCart() {
    let data = {
      customerId: this.customerId,
      classSessionData: this.classSessionData,
      passData: this.selectedPassId
    }
    this.dialogRef.close(data);
  }

  openPreviousDialog() {
    this.cancel();
    const dialogRef = this.dialog.open(AddSessionDialogComponent, {
      width: '700px',
      disableClose: true,
      autoFocus: false,
      data: {
        customerId: this.customerId,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
    });
  }
}